module.exports = "/OhNein@2x-7a44a0f4febad5467babd407ec676601.png";